import { useState, useRef, useEffect, useMemo } from 'react';
import styles from './listView.module.scss';
import { API_ROOT, sendRequest } from '../../../supplementary_components/requests';
import { addNotification } from '../../../supplementary_components/store';
import { FiFilter } from "react-icons/fi";
import { BsCalendar3 } from 'react-icons/bs';
import { QuickFiltrationComponent, updateNextBatchLink, appendFiltrationParams } from './quickFiltrationComponent';
import { dateFormatter } from '../../../supplementary_components/supplementaryMethods';
import { dateStringToLocalDateString } from '../../../pages/reports/weeklyReports';
import { addAndRemoveLoadingIcon } from '../item_page/driver_page_components/payoutAdjustmentsSection';
import { CalendarPicker, useCloseOnOutsidePress } from '../reusableItems/calendar';

export const FiltrationComponent = ({filtrationData, dataset, setFilteredData}) => {    
    const [multiFiltrationMode, setMultiFiltrationMode] = useState(false);
    const [filterUpdated, setFilterUpdated] = useState(false);
    if(multiFiltrationMode){
       
        return <form onSubmit={(e)=>{
            e.preventDefault();
            e.stopPropagation();
            addAndRemoveLoadingIcon(e.target.querySelector("button span"), false, "0.15rem", "white");
            setTimeout(() => {
                const formData = new FormData(e.target);
                // const searchTermsAndPatterns = Array.from(formData.entries())
                //     .filter(([key, value]) => value && value.trim() !== "")
                //     .map(([key, value]) => ({
                //         key: key,
                //         pattern: value.trim()
                //     }));
                const searchTermsAndPatterns = Array.from(formData.entries())
                    .filter(([key, value]) => value && value.trim() !== "")
                    .map(([key, value]) => {
                        const inputElement = e.target.querySelector(`input[name="${key}"]`);
                        const rawVal = inputElement ? inputElement.getAttribute('data-rawval') : null;
                        
                        let pattern = rawVal && rawVal !== "" ? rawVal.trim() : value.trim();
                        let endPattern = null;

                        if (rawVal && pattern.includes(',')) {
                            const splitIndex = pattern.indexOf(',');
                            endPattern = pattern.substring(splitIndex + 1).trim();
                            pattern = pattern.substring(0, splitIndex).trim();
                        }
                        return {
                            key: key,
                            pattern: pattern,
                            endPattern: endPattern
                        };
                    });
                if(searchTermsAndPatterns.length > 0){
                    // const updatedPayload = filtrationData.payloadGenerator(searchTermsAndPatterns, null);
                    const payload = {"searchTermsAndPatterns": searchTermsAndPatterns};
                    const nextLink = appendFiltrationParams(filtrationData.filtrationLinkRoot, {
                        batchSize: 50,
                        categoryLabel: filtrationData.categoryLabel,
                    });
                    sendRequest("POST", API_ROOT + nextLink, null, (res)=>{
                        if(res){
                            const lastId = res && res.length > 0 ? res[res.length-1].id : null;
                            setFilterUpdated(false);
                            setFilteredData({
                                dataset: res,
                                nextBatchLink : res.length >= 50 ? updateNextBatchLink(nextLink, lastId) : null,
                                nextBatchSize: 50,
                                loadMore: (onFinish, link, batchSize) => {
                                    sendRequest("POST", API_ROOT + link + (batchSize ? `&batchSize=${batchSize}` : ""), null, (res)=>{
                                        onFinish();
                                        if(res){
                                            const newLastId = res && res.length > 0 ? res[res.length-1].id : null;
                                            setFilteredData(prev => {
                                                const updatedArray = [...prev.dataset, ...res];
                                                return {
                                                    dataset : updatedArray,
                                                    nextBatchLink : res.length >= batchSize ? updateNextBatchLink(link, newLastId) : null,
                                                    nextBatchSize: batchSize * 2,
                                                    loadMore : res.length >= batchSize ? prev.loadMore : null
                                                }
                                            });
                                        }
                                    }, ()=>{
                                        onFinish();
                                        addNotification({message:`Something went wrong`, type:'alert'});
                                    }, payload);
                                }
                            });
                        }
                        addAndRemoveLoadingIcon(e.target.querySelector("button span"), true);
                    }, ()=>{
                        addNotification({message:`Something went wrong`, type:'alert'});
                        setFilterUpdated(false);
                        addAndRemoveLoadingIcon(e.target.querySelector("button span"), true);
                    }, payload);
                }else{
                    setFilterUpdated(false);
                    setFilteredData(null);
                }
                
            }, 50);
        }}>
        {
            filtrationData.searchByFieldNames.map((item, index)=>{
                if(item.searchKey && !item.notInMultiFilterMode){
                    return <SingleFiltrationComponent key={index} filtrationData={item} setFilterUpdated={setFilterUpdated} />
                    
                }
                return null;
            })
        }
        <button disabled={!filterUpdated} className={`${styles.multiFilterModeButton} ${filterUpdated ? styles.active : styles.inactive}`} 
        type="submit"><span>Apply</span></button>
        </form>
    }else{
        return <form>
        <QuickFiltrationComponent  filtrationData={filtrationData} dataset={dataset}  setFilteredData={setFilteredData} />
        {filtrationData.multipleFiltrationAllowed ? 
        <div className={styles.multipleFiltrationButton} onClick={()=>{
            setFilteredData(null);
            setMultiFiltrationMode(true)
        }}>
            <FiFilter />
        </div> : null}
    </form>
    }
    
}

const FILTER_CALENDAR_TYPES = new Set(['singleDate', 'range', 'both']);

function normalizeFilterCalendarPickType(t) {
	const s = t && String(t).toLowerCase();
	if (s && FILTER_CALENDAR_TYPES.has(s)) return s;
	return 'singleDate';
}

function stripFilterCalendarDay(d) {
	return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

function formatPickForFilterCalendar(d) {
	if (!d) return '';
	const t = stripFilterCalendarDay(d);
	const y = t.getFullYear();
	const mo = t.getMonth() + 1;
	const day = t.getDate();
	const intermediate = `${y}-${String(mo).padStart(2, '0')}-${String(day).padStart(2, '0')} 12:00 AM`;
	const { date } = dateFormatter(intermediate);
	if (date) return date;
	return `${String(mo).padStart(2, '0')}/${String(day).padStart(2, '0')}/${String(y).slice(-2)}`;
}

function parseFilterCalendarFragment(fragment) {
	if (!fragment || !String(fragment).trim()) return null;
	const { date, time } = dateFormatter(fragment.trim());
	if (!date) return null;
	const dm = date.match(/^(\d{2})\/(\d{2})\/(\d{2})$/);
	if (!dm) return null;
	const [, mo, d, yy] = dm;
	const year = 2000 + parseInt(yy, 10);
	if (!time) {
		return new Date(year, parseInt(mo, 10) - 1, parseInt(d, 10), 0, 0);
	}
	const tm = time.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
	if (!tm) return null;
	let h = parseInt(tm[1], 10);
	const mi = parseInt(tm[2], 10);
	const ap = tm[3].toUpperCase();
	if (ap === 'PM' && h !== 12) h += 12;
	if (ap === 'AM' && h === 12) h = 0;
	return new Date(year, parseInt(mo, 10) - 1, parseInt(d, 10), h, mi);
}

function parseFilterTextToCalendarInitialDates(raw, selectType) {
	if (!raw || !String(raw).trim()) return { initialStart: null, initialEnd: null };
	const rangeParts = String(raw).trim().split(/\s*(?:-|–|—)\s*/).filter((p) => p.length > 0);
	const canParseTwo =
		selectType !== 'singleDate' &&
		rangeParts.length >= 2 &&
		parseFilterCalendarFragment(rangeParts[0]) &&
		parseFilterCalendarFragment(rangeParts[1]);
	if (canParseTwo) {
		const a = parseFilterCalendarFragment(rangeParts[0]);
		const b = parseFilterCalendarFragment(rangeParts[1]);
		return {
			initialStart: a ? stripFilterCalendarDay(a) : null,
			initialEnd: b ? stripFilterCalendarDay(b) : null,
		};
	}
	const one = parseFilterCalendarFragment(String(raw).trim());
	return { initialStart: one ? stripFilterCalendarDay(one) : null, initialEnd: null };
}

const SingleFiltrationComponent = ({filtrationData, setFilterUpdated}) => {
    const inputField = useRef(null);
    const [filtrationText, setFiltrationText] = useState("");
    const selectOption = (e) => {
        const field = inputField.current
        if(field){
            let updatedValue = '';
            if(filtrationText !== ""){
                const selecteds = filtrationText.split(", ");
                if(selecteds.includes(e.target.innerText)){
                    updatedValue = selecteds.filter(item => item !== e.target.innerText).join(", ");
                }else{
                    updatedValue = selecteds.join(", ") + ", " + e.target.innerText;
                }
            }else{
                updatedValue = e.target.innerText;
            }
            setFiltrationText(updatedValue);
            inputField.current.focus();
        }
    }
    useEffect(()=>{
        setFilterUpdated(true);
    // eslint-disable-next-line 
    }, [filtrationText]);
    const selectedOptions = filtrationData.customSuggestions ? filtrationText.split(", ") : null;
    const calendarMode = Boolean(filtrationData.calendarPickType);
    const [calendarOpen, setCalendarOpen] = useState(false);
    const calendarShellRef = useRef(null);
    const calendarPopoverRef = useRef(null);
    const calendarOutsidePressRefs = useMemo(() => [calendarShellRef, calendarPopoverRef], []);
    useCloseOnOutsidePress(calendarMode && calendarOpen, calendarOutsidePressRefs, () => setCalendarOpen(false));

    const calendarSelectType = calendarMode ? normalizeFilterCalendarPickType(filtrationData.calendarPickType) : null;
    const { initialStart, initialEnd } = calendarMode
        ? parseFilterTextToCalendarInitialDates(filtrationText, calendarSelectType)
        : { initialStart: null, initialEnd: null };

    const applyCalendarSelection = (...args) => {
        const a = args[0];
        const b = args[1];
        const val =
            b === undefined
                ? formatPickForFilterCalendar(a)
                : `${formatPickForFilterCalendar(a)} - ${formatPickForFilterCalendar(b)}`;
        setFiltrationText(val);
        setCalendarOpen(false);
    };

    const showSuggestionsDropdown = () => {
        if (!filtrationData.customSuggestions || !inputField.current) return;
        const wrap = calendarMode ? calendarShellRef.current?.parentElement : inputField.current.parentElement;
        if (wrap && wrap.childNodes[1]) {
            wrap.childNodes[1].style.display = '';
        }
    };

    const hideSuggestionsDropdownIfNeeded = (inputEl) => {
        if (!filtrationData.customSuggestions || !inputEl) return;
        const wrap = calendarMode ? calendarShellRef.current?.parentElement : inputEl.parentElement;
        let selected = false;
        try {
            const suggestionsEl = wrap?.childNodes?.[1];
            if (suggestionsEl && suggestionsEl.childNodes) {
                for (const child of suggestionsEl.childNodes) {
                    if (child.matches?.(':hover')) {
                        selected = true;
                        break;
                    }
                }
            }
        } catch (error) {}
        if (!selected && wrap && wrap.childNodes[1]) {
            wrap.childNodes[1].style.display = 'none';
        }
    };

    const inputEl = (
        <input
            ref={inputField}
            placeholder={filtrationData.extendedHint || filtrationData.hint}
            className={styles.filtrationInput}
            name={filtrationData.searchKey}
            value={filtrationText}
            data-rawval={
                filtrationData.inputFormat === 'date'
                    ? filtrationText
                        .split(' - ')
                        .map((date) => dateStringToLocalDateString(date))
                    : ''
            }
            autoComplete="off"
            onFocus={(e) => {
                if (filtrationData.customSuggestions) {
                    showSuggestionsDropdown();
                }
            }}
            onBlur={(e) => {
                if (filtrationData.customSuggestions) {
                    hideSuggestionsDropdownIfNeeded(e.target);
                } else if (filtrationData.inputFormat === 'date') {
                    if (filtrationText && filtrationText !== '') {
                        let dates = [filtrationText];
                        if (filtrationText.includes('-')) {
                            const newArr = filtrationText.split('-');
                            if (newArr.length === 2) {
                                dates = newArr.map((date) => date.trim());
                            }
                        }
                        const finalArray = [];
                        for (let i = 0; i < dates.length; i++) {
                            const parsedDateObject = dateFormatter(dates[i]);
                            if (parsedDateObject.date) {
                                let parsedDate = parsedDateObject.date;
                                if (i > 0) {
                                    parsedDate = adjustDateIfBefore(
                                        finalArray[i - 1],
                                        parsedDate,
                                        parsedDateObject.yearNotSpecified
                                    );
                                }
                                if (parsedDate) {
                                    finalArray.push(parsedDate);
                                }
                            }
                        }
                        setFiltrationText(finalArray.join(' - '));
                    }
                }
            }}
            onChange={(e) => {
                const searchTerm = e.target?.value;
                if (filtrationData.customSuggestions && searchTerm && searchTerm !== '') {
                    return;
                }
                setFiltrationText(searchTerm || '');
            }}
        />
    );

    return (
        <div
            className={`${styles.filtrationComponent} ${styles.multiFilterMode}`}
            style={{ maxWidth: filtrationData.customMaxWidth || '12rem' }}
        >
            {calendarMode ? (
                <div ref={calendarShellRef} className={styles.filtrationCalendarRow}>
                    {inputEl}
                    <button
                        type="button"
                        className={styles.filtrationCalendarBtn}
                        aria-label="Open calendar"
                        tabIndex={-1}
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={(e) => {
                            e.stopPropagation();
                            setCalendarOpen((o) => !o);
                        }}
                    >
                        <BsCalendar3 />
                    </button>
                    {calendarOpen ? (
                        <CalendarPicker
                            key={`${filtrationText}-${calendarSelectType}-${calendarOpen}`}
                            selectType={calendarSelectType}
                            popoverAlign="end"
                            anchorRef={calendarShellRef}
                            popoverRef={calendarPopoverRef}
                            initialStart={initialStart || undefined}
                            initialEnd={initialEnd || undefined}
                            onCancel={() => setCalendarOpen(false)}
                            onApply={applyCalendarSelection}
                        />
                    ) : null}
                </div>
            ) : (
                inputEl
            )}
            {filtrationData.customSuggestions ? (
                <div style={{ display: 'none' }} className={`${styles.suggestionsBox} non-selectable`}>
                    {filtrationData.customSuggestions.map((val, index) => {
                        return (
                            <div key={index} onClick={selectOption}>
                                <span
                                    className={`filterOption ${
                                        selectedOptions && selectedOptions.includes(val) ? styles.selectedOption : ''
                                    }`}
                                >
                                    {val}{' '}
                                </span>
                            </div>
                        );
                    })}
                </div>
            ) : null}
        </div>
    );
}
function adjustDateIfBefore(dateStr1, dateStr2, yearNotSpecified) {
    const createDate = (str) => new Date(str);
    let date1 = createDate(dateStr1);
    let date2 = createDate(dateStr2);
    if (date2 < date1) {
        if(yearNotSpecified){
            const currentYear = date2.getFullYear();
            date2.setFullYear(currentYear + 1);
            const month = String(date2.getMonth() + 1).padStart(2, '0');
            const day = String(date2.getDate()).padStart(2, '0');
            const year = String(date2.getFullYear()).slice(-2);
            return `${month}/${day}/${year}`;
        }else{
            return null;
        }
    } else {
        return dateStr2
    }    
}


export function dynamicFilter(dataset, searchTerm, properties, typeSelected, searchTermTransformer, exactMatch, filtersSplittingChar, conditionalCheck) {
    searchTerm = searchTerm.toLowerCase().trim();
    if (!searchTerm) {
        // Return the whole dataset if the search term is empty
        return dataset;
    }
    let arrayOfPatterns = null;
    if(typeSelected){
        const splittingChar = filtersSplittingChar|| ",";
        if(searchTerm.includes(splittingChar)){
            arrayOfPatterns = searchTerm.split(splittingChar).map(pattern => searchTermTransformer ? searchTermTransformer(pattern.trim()) : pattern.trim());
        }else{
            searchTerm = searchTermTransformer ? searchTermTransformer(searchTerm) : searchTerm;
        }
    }
    // Function to safely get a nested property value
    const getValue = (obj, path) => {
        // Split the path (e.g., 'currentTruck.truckNumber') into parts
        const parts = path.split('.');
        let value = obj;
        // Traverse the object using the parts
        for (const part of parts) {
            if (value && typeof value === 'object' && part in value) {
                
                value = value[part];
            } else {
                // Return null if any part of the path is missing or invalid
                return null;
            }
        }
        
        return value;
    };

    // Use Array.prototype.filter to process the dataset
    return dataset.filter(item => {
        if(typeSelected && conditionalCheck){
            const res = conditionalCheck(searchTerm, item);
            return res
        }
        // Check if ANY of the specified properties include the search term
        return properties.some(propertyConf => {
            const valueLocation = typeSelected ? propertyConf : propertyConf.valueLocation;
            if(!valueLocation)return false;
            let transformedTerm = null;
            if(!typeSelected && propertyConf.searchTermTransformer){
                transformedTerm = propertyConf.searchTermTransformer(searchTerm);
            }
            if(Array.isArray(valueLocation)){
                if(!typeSelected && propertyConf.notInInlineFilterMode)return false;
                if(searchTerm.includes("-")){
                    const splitIndex = searchTerm.indexOf("-");
                    const firstPart = searchTerm.substring(0, splitIndex).trim();
                    const secondPart = searchTerm.substring(splitIndex + 1).trim();
                    
                    if(valueLocation.length < 2) return false;

                    const val1 = getValue(item, valueLocation[0]);
                    const val2 = getValue(item, valueLocation[1]);

                    const match1 = typeof val1 === 'string' && val1.toLowerCase().includes(firstPart);
                    const match2 = typeof val2 === 'string' && val2.toLowerCase().includes(secondPart);

                    return match1 && match2;
                }else{
                    return valueLocation.some(path => {
                        const value = getValue(item, path);
                        if (typeof value === 'string') {
                            return value.toLowerCase().includes(searchTerm);
                        }
                        return false;
                    });
                }
            }

            let value = getValue(item, valueLocation);
            
            if (typeof value === 'string') {
                value = value.toLowerCase();
                if(arrayOfPatterns){
                    return arrayOfPatterns.some(pattern => {
                        return exactMatch ? value === pattern : value.includes(pattern);
                    });
                }else{
                    if(transformedTerm){
                        return value === transformedTerm;
                    }
                    return exactMatch ?  value === searchTerm : value.includes(searchTerm);
                }
            }

            // If the property value is null or not a string, it doesn't match
            return false;
        });
    });
}